import 'magnific-popup';

$(function () {
    accordionToggle();
    // imagePopup();
})

function accordionToggle() {
    $('.accordions__accordion__title').on('click', function () {
        $(this).parent().toggleClass('opened');
        $(this).next('.accordions__accordion__hidden').slideToggle();
    });
}

function imagePopup() {
    $('.accordions__accordion__hidden__description img').each(function () {
        $(this).parent().append('<img class="open-popup" src="/wp-content/themes/calcimedica/dist/images/svg/open-popup.svg" alt="open">');
    });
    $('.open-popup').each(function () {
        var
            imgUrl = $(this).siblings('img').attr("src"),
            imgClass = $(this).siblings('img').attr("class");
            imgAlt = $(this).siblings('img').attr('alt');
        $(this).siblings('img').addBack().wrapAll('<div class="image-with-popup"/>');
        $(this).siblings('img').wrap('<a href=' + imgUrl + ' alt=' + imgAlt +'>');
        $(this).addClass(imgClass);
    })
    $('.open-popup').each(function () {
        $(this).siblings('a').magnificPopup({
            type: 'image',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
    })
    $('.open-popup').on('click', function () {
        $(this).siblings('a').magnificPopup('open');
    })
}

